import { Component, Prop, h, Host, Listen, Element, State } from '@stencil/core';
import { translations } from './translations';
import { SideMenui18n } from './types';
import state from './pn-sidenav-store';
import { close_small, bars } from "pn-design-assets/pn-assets/icons";

@Component({
  tag: 'pn-sidenav-togglebutton',
  styleUrl: 'pn-sidenav-togglebutton.scss',
  shadow: false,
})
export class PnSidenavTogglebutton {
  @Element() hostElement: HTMLElement;
  /** Specifies which language we want to show navigation in (sv,da,fi,no,en) */
  @Prop() label: string = '';

  @State() i18n: SideMenui18n = { open: '', close: '', navLabel: '' };

  onClick() {
    state.openMenu = !state.openMenu;
    const body = document.querySelector('body');
    body.setAttribute('data-siteheader-sidemenuopen', state.openMenu + '');
  }
  render() {
    return (
      <Host>
        <pn-button appearance="light" icon={state.openMenu ? close_small : bars} left-icon={true} small={true} onclick={this.onClick.bind(this)} label={this.label}>
          <slot />
        </pn-button>
      </Host>
    );
  }
}
